import type { AnyAction } from 'redux';
import type { ThunkAction } from 'redux-thunk';

import { IAppState, IThunkExtraArgument } from '../../common/state';

/**
 * Обновляет данные шапки (регион, счетчики и т.д.) через API микрофронтенда шапки
 */
export function reloadHeader(): ThunkAction<void, IAppState, IThunkExtraArgument, AnyAction> {
  return (_dispatch, _getState, { microfrontendsAPI }) => {
    if (!microfrontendsAPI) {
      return;
    }

    void microfrontendsAPI.header.updateHeader();
  };
}
